import { Image } from "@clipboard-health/ui-components";

import clipboardLogoWithoutWatermark from "../assets/images/cbh-logo-without-wordmark.png";

interface ClipboardLogoProps {
  width?: number;
}

export function ClipboardLogo(props: ClipboardLogoProps = {}) {
  const { width = 120 } = props;
  return <Image src={clipboardLogoWithoutWatermark} alt="Clipboard" width={width} />;
}
